import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { TaskStatus, TaskPriority } from '../types/models';

interface FiltersState {
  search: string;
  assignee: string | null;
  status: TaskStatus | null;
  priority: TaskPriority | null;
}

const initialState: FiltersState = {
  search: '',
  assignee: null,
  status: null,
  priority: null,
};

const slice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    setSearch(state, action: PayloadAction<string>) {
      state.search = action.payload;
    },
    setAssigneeFilter(state, action: PayloadAction<string | null>) {
      state.assignee = action.payload;
    },
    setStatusFilter(state, action: PayloadAction<TaskStatus | null>) {
      state.status = action.payload;
    },
    setPriorityFilter(state, action: PayloadAction<TaskPriority | null>) {
      state.priority = action.payload;
    },
    clearFilters() {
      return initialState;
    },
  },
});

export const {
  setSearch,
  setAssigneeFilter,
  setStatusFilter,
  setPriorityFilter,
  clearFilters,
} = slice.actions;
export default slice.reducer;
